exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".link[data-v-186aac56]{display:flex;align-items:center}.link__icon[data-v-186aac56]{width:20px;height:20px;margin-right:20px}", ""]);

